import {OptionType} from '@jobseeker/lotus/elements/Select';

export const courseType: {[key: number]: string} = {
  [1]: 'Full Time',
  [2]: 'Part Time',
  [3]: 'Distance Learning program',
  [4]: 'Executive Program',
  [5]: 'Certification',
};

export const degreeType: {[key: number]: string} = {
  [1]: 'MBA / PGDM',
  [2]: 'CA',
  [3]: 'CS',
  [4]: 'ICWA',
  [5]: 'LLB / LLM',
  [6]: 'B Tech / BE',
  [7]: 'MBBS',
  [8]: 'BSc',
  [9]: 'BA',
  [10]: 'Bcom',
  [11]: 'BBA',
  [12]: 'Other',
  [13]: 'PhD',
  [14]: 'MSc / MS / M Tech',
  [15]: 'MA',
  [16]: 'Integrated Masters Program',
  [17]: 'CFA',
  [18]: 'FRM',
  [19]: 'BCA',
  [20]: 'MCA',
  [21]: 'BArch',
  [22]: 'CWM',
  [23]: 'AFA',
  [24]: 'Passed CFA Level 1',
  [25]: 'Passed CFA Level 2',
  [26]: 'Passed CFA Level 3',
  [27]: 'PGDDA',
};
const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

export const statusOptions: OptionType[] = isAppIimjobs
  ? [
      {label: 'All Applications', value: 1},
      {label: 'Shortlisted', value: 2},
      {label: 'Not Suitable', value: 3},
      {label: 'Saved For Future', value: 4},
      {label: 'Viewed', value: 5},
      {label: 'Downloaded', value: 6},
      // {label: 'YOUR STATUS HAS BEEN CHANGED', value: 101},
      {label: 'Followed Up', value: 7},
      {label: 'Round Zero Viewed', value: 10},
    ]
  : [
      {label: 'Shortlisted', value: 2},
      {label: 'Not Suitable', value: 3},
      {label: 'Saved For Future', value: 4},
      {label: 'Viewed', value: 5},
      {label: 'Downloaded', value: 6},
      // {label: 'YOUR STATUS HAS BEEN CHANGED', value: 101},
      {label: 'Followed Up', value: 7},
      {label: 'Round Zero Viewed', value: 10},
    ];
